import { render, staticRenderFns } from "./SubmitQuestions.vue?vue&type=template&id=5a752303&scoped=true"
import script from "./SubmitQuestions.vue?vue&type=script&lang=js"
export * from "./SubmitQuestions.vue?vue&type=script&lang=js"
import style0 from "./SubmitQuestions.vue?vue&type=style&index=0&id=5a752303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a752303",
  null
  
)

export default component.exports